import Vue from 'vue';
import {isIOS,requestWxStr} from "@/utils/map"
import App from './App.vue';
import store from './store';
import router from './router';
// import './router/permission';
import './core/use';

import './utils/filter'

// import Vconsole from 'vconsole'

// const vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.config.productionTip = false;


router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
  /* vue-router用的history模式，在微信签名验证的时候iOS验证URL第一次进来的URL */
  if (isIOS()) {
    if (from.path === '/') {
      requestWxStr() // 该函数和之前一样，被单独提取出来了
    }
  }

  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  next()// 执行进入路由，如果不写就不会进入目标页
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
